import { render, staticRenderFns } from "./MobileNews.vue?vue&type=template&id=f63275e8&scoped=true&"
import script from "./MobileNews.vue?vue&type=script&lang=js&"
export * from "./MobileNews.vue?vue&type=script&lang=js&"
import style0 from "./MobileNews.vue?vue&type=style&index=0&id=f63275e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63275e8",
  null
  
)

export default component.exports